import React, { useEffect, useRef, useState } from "react";
import useOnClickOutside from "use-onclickoutside";
import "./drutasDropdown.scss";

/**
 * used to render the search bar for selection custom components in filter popup
 * @param {*} props
 * @author {Prachi Jain}
 */
export const DrutasDropdown = React.memo((props) => {
  const { value, onChange, data, label, key, className, popupClass, isfilter, filterContent, itemRender, valueRender, disabled, clearFilterText, onOpen, id } =
    props;
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const dynamicSearchRef = useRef(null);
  const popupRef = useRef(null);
  const isPopupOpenRef = useRef(false);

  useEffect(() => {
    isPopupOpenRef.current = isPopupOpen;
  }, [isPopupOpen]);

  /**
   * Opens the popup
   * @author Bhavana
   */
  useEffect(() => {
    if (!isPopupOpen || !onOpen) return;
    let cancelled = false;
    const id = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!cancelled) onOpen(popupRef.current);
      });
    });
    return () => {
      cancelled = true;
      cancelAnimationFrame(id);
    };
  }, [isPopupOpen, onOpen]);

  useOnClickOutside(dynamicSearchRef, () => {
    if (isPopupOpenRef.current) {
      clearFilterText?.();
    }
    setIsPopupOpen(false);
  });

  const togglePopup = () => {
    if (disabled) return;
    if (isPopupOpen) clearFilterText?.();
    setIsPopupOpen(!isPopupOpen);
  };

  const handleOnClick = (item) => {
    clearFilterText?.();
    onChange(item);
    setIsPopupOpen(false);
  };

  return (
    <div
      id={id}
      className={`drutas-dropdown-container ${className ? className : ""} ${!!disabled ? "cursor-default" : ""}`}
      ref={dynamicSearchRef}>
      <div
        id={id ? `${id}-value` : undefined}
        className={`drutas-dropdown-value-container ${!!disabled ? "cursor-default" : "cursor-pointer"}`}>
        <div onClick={togglePopup} className={`truncate-text ${!!disabled ? "cursor-default" : "cursor-pointer"}`}>
          {valueRender ? valueRender(value) : value ? value[label] : "select"}
        </div>
      </div>
      {isPopupOpen && (
        <div ref={popupRef} id={id ? `${id}-popup` : undefined} className={`drutas-dropdown-popup  ${popupClass ? popupClass : ""}`}>
          {isfilter && filterContent()}
          {data && !!data.length ? (
            <div className='drutas-dropdown-popup-elements'>
              {data?.map((item) => {
                return itemRender ? (
                  itemRender(item, handleOnClick)
                ) : (
                  <span className='drutas-dropdown-popup-element truncate-text' key={item?.[key]} title={item?.[label]} onClick={() => handleOnClick(item)}>
                    {item?.[label]}
                  </span>
                );
              })}
            </div>
          ) : (
            <>No data Item</>
          )}
        </div>
      )}
    </div>
  );
});
